import { type FunctionComponent } from 'react';
import { type IconProps } from '../types';
import { IconWrapper } from '../style';

export const Book: FunctionComponent<IconProps> = ({
  color,
  rotation,
  width = '24px',
  height = '24px',
  cursor,
}: IconProps) => (
  <IconWrapper width={width} height={height} cursor={cursor}>
    <svg
      width="100%"
      height="100%"
      xmlns="http://www.w3.org/2000/svg"
      transform={`rotate(${rotation ?? 0})`}
      fill="none"
      viewBox="0 0 45 41"
    >
      <path
        fill={color ?? 'currentColor'}
        d="M14.1201 0C17.643 1.18307e-05 20.7343 1.83558 22.499 4.60059C24.2634 1.83532 27.3559 6.7522e-05 30.8789 0H43.4297C44.2964 0.000263666 45 0.70254 45 1.56934V32.9648C44.9999 33.8316 44.2964 34.5339 43.4297 34.5342H28.7871C26.1891 34.5343 24.0811 36.6425 24.0811 39.2441L24.0732 39.4043C23.9928 40.1957 23.3243 40.8132 22.5117 40.8135C22.5076 40.8135 22.5031 40.8125 22.499 40.8125C22.4951 40.8125 22.4912 40.8135 22.4873 40.8135C21.6207 40.8132 20.9182 40.1108 20.918 39.2441C20.918 36.6424 18.81 34.5342 16.2119 34.5342H1.56934C0.70243 34.5342 8.55757e-05 33.8317 0 32.9648V1.56934C0 0.702377 0.702377 0 1.56934 0H14.1201ZM3.13867 31.3945H16.2119C17.9775 31.3945 19.6071 31.9783 20.918 32.9629V9.94141C20.918 6.18377 17.8735 3.13869 14.1201 3.13867H3.13867V31.3945ZM30.8789 3.13867C27.1256 3.13878 24.0811 6.18383 24.0811 9.94141V32.9629C25.3919 31.9783 27.0215 31.3946 28.7871 31.3945H41.8604V3.13867H30.8789Z"
      />
    </svg>
  </IconWrapper>
);

Book.displayName = 'Book';
